import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { SelectAllOptionComponent } from './select-all-option/select-all-option.component';
import { SelectSearchComponent } from './select-search/select-search.component';

@NgModule({
  declarations: [SelectSearchComponent, SelectAllOptionComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    MatSelectTrigger,
    FormsModule,
  ],
  exports: [SelectSearchComponent, SelectAllOptionComponent],
})
export class GaFormsModule {}
